import { EventInput } from '@fullcalendar/core'

declare global {
  interface Window {
    drupalSettings: any;
  }
}

let eventGuid = 0
let todayStr = new Date().toISOString().replace(/T.*$/, '')

export const INITIAL_EVENTS: EventInput[] = window.drupalSettings.fullcalendar_react;

// export const INITIAL_EVENTS: EventInput[] = [
//   {
//     id: createEventId(),
//     title: 'All-day event',
//     start: todayStr
//   },
//   {
//     id: createEventId(),
//     title: 'Timed event',
//     start: todayStr + 'T12:00:00'
//   }
// ]

export function createEventId() {
  return String(eventGuid++)
}
